class MtKjHeader {
  constructor(root) {
    this.root = root;
    this.sectionContainer = this.root.parentElement;
    this.mobile = this.root.querySelector('.mt-kj-header__mobile');
    this.burger = this.root.querySelector('.mt-kj-header__burger');
    this.closeEls = Array.from(this.root.querySelectorAll('[data-kj-header-close]'));
    this.searchBtns = Array.from(this.root.querySelectorAll('[data-kj-header-search]'));
    this.cartBtns = Array.from(this.root.querySelectorAll('[data-kj-header-cart]'));
    this.bannerCopyBtns = Array.from(this.root.querySelectorAll('[data-banner-copy]'));
    this.mega = this.root.querySelector('[data-kj-mega]');
    this.topItems = Array.from(this.root.querySelectorAll('[data-kj-top-item]'));
    this.megaPanels = Array.from(this.root.querySelectorAll('[data-kj-mega-panel]'));
    this.megaItems = Array.from(this.root.querySelectorAll('[data-kj-mega-item]'));
    this.megaToggles = Array.from(this.root.querySelectorAll('[data-kj-mega-toggle]'));
    this.productContainers = Array.from(this.root.querySelectorAll('[data-kj-mega-products]'));
    this.mobileAccItems = Array.from(this.root.querySelectorAll('[data-kj-mobile-acc-item]'));
    this.mobileItems = Array.from(this.root.querySelectorAll('[data-kj-mobile-item]'));
    this._lastActive = null;
    this._closeTimer = null;
    this._activeTopIndex = null;
    this._mobileHideTimer = null;
    this._bannerCopyTimers = new Map();
    this._lastProductSelectionByParent = new Map();

    this._onBurgerClick = this._onBurgerClick.bind(this);
    this._onCloseClick = this._onCloseClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onSearchClick = this._onSearchClick.bind(this);
    this._onCartClick = this._onCartClick.bind(this);
    this._onBannerCopy = this._onBannerCopy.bind(this);
    this._onTopEnter = this._onTopEnter.bind(this);
    this._onTopLeave = this._onTopLeave.bind(this);
    this._onMegaLeave = this._onMegaLeave.bind(this);
    this._onMegaEnter = this._onMegaEnter.bind(this);
    this._onMegaItemEnter = this._onMegaItemEnter.bind(this);
    this._onMegaSubLinkEnter = this._onMegaSubLinkEnter.bind(this);
    this._onMegaToggleClick = this._onMegaToggleClick.bind(this);
    this._onMobileAccToggle = this._onMobileAccToggle.bind(this);
    this._onMobileItemToggle = this._onMobileItemToggle.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._onResize = this._onResize.bind(this);

    if (this.burger) this.burger.addEventListener('click', this._onBurgerClick);
    this.closeEls.forEach((el) => el.addEventListener('click', this._onCloseClick));
    this.searchBtns.forEach((btn) => btn.addEventListener('click', this._onSearchClick));
    this.cartBtns.forEach((btn) => btn.addEventListener('click', this._onCartClick));
    this.bannerCopyBtns.forEach((btn) => btn.addEventListener('click', this._onBannerCopy));

    this._bindMega();
    this._bindMobileAccordion();
    this._hideAllProducts();
    this._syncSticky();
    this._initBannerCarousel();
    window.addEventListener('resize', this._onResize);
    this._onResize();
  }

  _initBannerCarousel() {
    const carousel = this.root.querySelector('[data-banner-carousel]');
    if (!carousel) return;
    const slides = Array.from(carousel.querySelectorAll('[data-banner-slide]'));
    if (slides.length <= 1) return;

    this._bannerIndex = 0;
    this._bannerSlides = slides;
    this._bannerCarousel = carousel;

    this._bannerTimer = setInterval(() => {
      this._bannerSlides[this._bannerIndex].classList.remove('is-active');
      this._bannerIndex = (this._bannerIndex + 1) % this._bannerSlides.length;
      const next = this._bannerSlides[this._bannerIndex];
      next.classList.add('is-active');
      // 同步背景色
      const bg = next.getAttribute('data-banner-bg');
      const tc = next.getAttribute('data-banner-text-color');
      if (bg) this._bannerCarousel.style.setProperty('--mt-kj-header-banner-bg', bg);
      if (tc) this._bannerCarousel.style.setProperty('--mt-kj-header-banner-text', tc);
    }, 4000);
  }

  async _onBannerCopy(event) {
    const button = event.currentTarget;
    const text = button.getAttribute('data-copy-text') || '';
    if (!text) return;

    const copied = await this._copyText(text);
    if (!copied) return;

    const status = button.querySelector('[data-banner-copy-status]');
    const successText = button.getAttribute('data-copy-success') || 'Copied!';
    const existingTimer = this._bannerCopyTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    if (status) status.textContent = successText;
    button.classList.add('is-copied');

    const timer = window.setTimeout(() => {
      button.classList.remove('is-copied');
      if (status) status.textContent = '';
      this._bannerCopyTimers.delete(button);
    }, 1800);
    this._bannerCopyTimers.set(button, timer);
  }

  async _copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        // Fall through to the legacy copy method.
      }
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    textarea.remove();
    return copied;
  }

  destroy() {
    if (this.burger) this.burger.removeEventListener('click', this._onBurgerClick);
    this.closeEls.forEach((el) => el.removeEventListener('click', this._onCloseClick));
    this.searchBtns.forEach((btn) => btn.removeEventListener('click', this._onSearchClick));
    this.cartBtns.forEach((btn) => btn.removeEventListener('click', this._onCartClick));
    this.bannerCopyBtns.forEach((btn) => btn.removeEventListener('click', this._onBannerCopy));
    this._bannerCopyTimers.forEach((timer) => window.clearTimeout(timer));
    this._bannerCopyTimers.clear();
    this._unbindMega();
    this._unbindMobileAccordion();
    document.removeEventListener('keydown', this._onKeyDown);
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    this._unlockScroll();
    if (this._bannerTimer) clearInterval(this._bannerTimer);
  }

  _syncSticky() {
    const enabled = this.root.getAttribute('data-sticky-enabled');
    const isEnabled = enabled === 'true' || enabled === '1';
    this.root.classList.toggle('is-sticky', isEnabled);
    window.removeEventListener('scroll', this._onScroll);
    if (isEnabled) {
      this._updatePlaceholder();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
      return;
    }
    this.root.classList.remove('is-scrolled');
    this.root.classList.remove('is-pinned');
    this._updatePlaceholder();
  }

  _onScroll() {
    const scrollTop = window.scrollY || window.pageYOffset || 0;
    const isPinned = scrollTop > 0;
    this.root.classList.toggle('is-scrolled', isPinned);
    this.root.classList.toggle('is-pinned', isPinned);
    this._updatePlaceholder();
  }

  _onResize() {
    if (window.innerWidth > 980) {
      this._closeMobile();
    }
  }

  _updatePlaceholder() {
    if (!this.sectionContainer) return;
    this.sectionContainer.style.minHeight = '';
  }

  _isOpen() {
    return this.mobile && !this.mobile.hasAttribute('hidden');
  }

  _openMobile() {
    if (!this.mobile || this._isOpen()) return;
    if (this._mobileHideTimer) {
      window.clearTimeout(this._mobileHideTimer);
      this._mobileHideTimer = null;
    }
    this._lastActive = document.activeElement;
    this.mobile.removeAttribute('hidden');
    this.root.classList.add('is-menu-open');
    if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', this._onKeyDown);
    this._lockScroll();
    window.requestAnimationFrame(() => {
      if (!this.mobile || this.mobile.hasAttribute('hidden')) return;
      this.mobile.classList.add('is-open');
    });

    const focusTarget =
      this.mobile.querySelector('.mt-kj-header__mobile-close') ||
      this.mobile.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
    if (focusTarget) this._focusWithoutScroll(focusTarget);
  }

  _closeMobile() {
    if (!this.mobile || !this._isOpen()) return;
    this.mobile.classList.remove('is-open');
    this.root.classList.remove('is-menu-open');
    if (this._mobileHideTimer) window.clearTimeout(this._mobileHideTimer);
    this._mobileHideTimer = window.setTimeout(() => {
      if (!this.mobile) return;
      this.mobile.setAttribute('hidden', '');
      this._mobileHideTimer = null;
    }, 340);
    if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', this._onKeyDown);
    this._unlockScroll();
    if (this._lastActive && this._lastActive.focus) this._focusWithoutScroll(this._lastActive);
    this._lastActive = null;
  }

  _toggleMobile() {
    if (this._isOpen()) this._closeMobile();
    else this._openMobile();
  }

  _lockScroll() {
    if (document.documentElement.dataset.mtKjHeaderLocked === '1') return;
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.dataset.mtKjHeaderLocked = '1';
    this._prevHtmlOverflow = document.documentElement.style.overflow;
    this._prevBodyPosition = document.body.style.position;
    this._prevBodyTop = document.body.style.top;
    this._prevBodyWidth = document.body.style.width;
    this._prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  _unlockScroll() {
    if (document.documentElement.dataset.mtKjHeaderLocked !== '1') return;
    const scrollY = this._scrollY || 0;
    document.documentElement.style.overflow = this._prevHtmlOverflow || '';
    document.body.style.position = this._prevBodyPosition || '';
    document.body.style.top = this._prevBodyTop || '';
    document.body.style.width = this._prevBodyWidth || '';
    document.body.style.overflow = this._prevBodyOverflow || '';
    delete document.documentElement.dataset.mtKjHeaderLocked;
    window.scrollTo(0, scrollY);
  }

  _focusWithoutScroll(el) {
    if (!el || !el.focus) return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  _onBurgerClick() {
    this._toggleMobile();
  }

  _onCloseClick() {
    this._closeMobile();
  }

  _onKeyDown(e) {
    if (e.key === 'Escape') this._closeMobile();
  }

  _onSearchClick(e) {
    e.preventDefault();
    if (typeof window.openSearchDrawer === 'function') {
      window.openSearchDrawer();
      return;
    }
    const btn = e.currentTarget;
    const url = (btn && btn.getAttribute && btn.getAttribute('data-search-url')) || '/search';
    window.location.href = url;
  }

  _onCartClick(e) {
    e.preventDefault();
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return;
    }
    const btn = e.currentTarget;
    const url = (btn && btn.getAttribute && btn.getAttribute('data-cart-url')) || '/cart';
    window.location.href = url;
  }

  _bindMega() {
    if (!this.mega || this.topItems.length === 0) return;
    this.topItems.forEach((item) => {
      item.addEventListener('mouseenter', this._onTopEnter);
      item.addEventListener('mouseleave', this._onTopLeave);
      const link = item.querySelector('[data-kj-top-link]');
      if (link) link.addEventListener('focus', this._onTopEnter);
    });
    this.mega.addEventListener('mouseenter', this._onMegaEnter);
    this.mega.addEventListener('mouseleave', this._onMegaLeave);
    this.root.addEventListener('mouseleave', this._onMegaLeave);
    this.megaToggles.forEach((btn) => btn.addEventListener('click', this._onMegaToggleClick));
    this.megaItems.forEach((item) => {
      item.addEventListener('mouseenter', this._onMegaItemEnter);
      item.addEventListener('focusin', this._onMegaItemEnter);
    });
    this.root.querySelectorAll('[data-kj-mega-sub-link]').forEach((a) => {
      a.addEventListener('mouseenter', this._onMegaSubLinkEnter);
      a.addEventListener('focus', this._onMegaSubLinkEnter);
    });
  }

  _bindMobileAccordion() {
    if (this.mobileAccItems.length === 0) return;
    this.mobileAccItems.forEach((item) => {
      const btn = item.querySelector('[data-kj-mobile-acc-toggle]');
      if (!btn) return;
      btn.addEventListener('click', this._onMobileAccToggle);
    });
    this.mobileItems.forEach((item) => {
      const btn = item.querySelector('[data-kj-mobile-toggle]');
      if (!btn) return;
      btn.addEventListener('click', this._onMobileItemToggle);
    });
  }

  _unbindMobileAccordion() {
    if (this.mobileAccItems.length === 0) return;
    this.mobileAccItems.forEach((item) => {
      const btn = item.querySelector('[data-kj-mobile-acc-toggle]');
      if (!btn) return;
      btn.removeEventListener('click', this._onMobileAccToggle);
    });
    this.mobileItems.forEach((item) => {
      const btn = item.querySelector('[data-kj-mobile-toggle]');
      if (!btn) return;
      btn.removeEventListener('click', this._onMobileItemToggle);
    });
  }

  _onMobileAccToggle(e) {
    const btn = e.currentTarget;
    if (!btn) return;
    const item = btn.closest('[data-kj-mobile-acc-item]');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');
    this.mobileAccItems.forEach((it) => {
      this._setMobileAccordionItemState(it, false);
    });

    if (isOpen) return;
    this._setMobileAccordionItemState(item, true);
    this._expandAllMobileItems(item);
  }

  _onMobileItemToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    if (!btn) return;
    const item = btn.closest('[data-kj-mobile-item]');
    if (!item) return;
    const shouldOpen = !item.classList.contains('is-active');
    item.classList.toggle('is-active', shouldOpen);
    btn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  _expandAllMobileItems(section) {
    if (!section) return;
    section
      .querySelectorAll('[data-kj-mobile-item][data-kj-collapsible="true"]')
      .forEach((item) => {
        item.classList.add('is-active');
        const btn = item.querySelector('[data-kj-mobile-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });
  }

  _setMobileAccordionItemState(item, shouldOpen) {
    if (!item) return;
    const btn = item.querySelector('[data-kj-mobile-acc-toggle]');
    const body = item.querySelector('[data-kj-mobile-acc-body]');
    if (btn) btn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (!body) {
      item.classList.toggle('is-open', shouldOpen);
      return;
    }

    if (body._kjHideTimer) {
      window.clearTimeout(body._kjHideTimer);
      body._kjHideTimer = null;
    }

    if (shouldOpen) {
      body.hidden = false;
      window.requestAnimationFrame(() => {
        item.classList.add('is-open');
      });
      return;
    }

    item.classList.remove('is-open');
    body._kjHideTimer = window.setTimeout(() => {
      body.hidden = true;
      body._kjHideTimer = null;
    }, 360);
  }

  _unbindMega() {
    if (!this.mega || this.topItems.length === 0) return;
    this.topItems.forEach((item) => {
      item.removeEventListener('mouseenter', this._onTopEnter);
      item.removeEventListener('mouseleave', this._onTopLeave);
      const link = item.querySelector('[data-kj-top-link]');
      if (link) link.removeEventListener('focus', this._onTopEnter);
    });
    this.mega.removeEventListener('mouseenter', this._onMegaEnter);
    this.mega.removeEventListener('mouseleave', this._onMegaLeave);
    this.root.removeEventListener('mouseleave', this._onMegaLeave);
    this.megaToggles.forEach((btn) => btn.removeEventListener('click', this._onMegaToggleClick));
    this.megaItems.forEach((item) => {
      item.removeEventListener('mouseenter', this._onMegaItemEnter);
      item.removeEventListener('focusin', this._onMegaItemEnter);
    });
    this.root.querySelectorAll('[data-kj-mega-sub-link]').forEach((a) => {
      a.removeEventListener('mouseenter', this._onMegaSubLinkEnter);
      a.removeEventListener('focus', this._onMegaSubLinkEnter);
    });
  }

  _onTopEnter(e) {
    const item = e.currentTarget && e.currentTarget.matches && e.currentTarget.matches('[data-kj-top-item]')
      ? e.currentTarget
      : e.currentTarget && e.currentTarget.closest
        ? e.currentTarget.closest('[data-kj-top-item]')
        : null;
    if (!item) return;
    if (!item.classList.contains('has-dropdown')) {
      this._closeMega();
      return;
    }
    const idx = item.getAttribute('data-kj-top-index');
    if (idx === null || idx === undefined) return;
    this._openMega(idx);
  }

  _onTopLeave() {
    this._scheduleCloseMega();
  }

  _onMegaEnter() {
    this._clearCloseTimer();
  }

  _onMegaLeave() {
    this._scheduleCloseMega();
  }

  _openMega(index) {
    if (!this.mega) return;
    this._clearCloseTimer();
    this.root.classList.add('is-mega-open');
    this.mega.classList.add('is-open');
    this.mega.setAttribute('aria-hidden', 'false');
    this._activeTopIndex = String(index);
    this.topItems.forEach((item) => {
      const idx = item.getAttribute('data-kj-top-index');
      item.classList.toggle('is-open', idx === String(index));
    });

    this.megaPanels.forEach((panel) => {
      const idx = panel.getAttribute('data-kj-top-index');
      panel.classList.toggle('is-active', idx === String(index));
    });

    const activePanel = this.mega.querySelector('[data-kj-mega-panel].is-active');
    if (activePanel) {
      const parentTitle = activePanel.getAttribute('data-kj-parent-title') || '';
      this._prepareProductsForParent(parentTitle);
      this._expandAllMegaItems(activePanel);
      const activeItem =
        activePanel.querySelector('[data-kj-mega-item].is-active') ||
        activePanel.querySelector('[data-kj-mega-item]');
      if (activeItem) this._activateMegaItem(activeItem);
    } else {
      this._hideAllProducts();
    }
  }

  _closeMega() {
    if (!this.mega) return;
    this._clearCloseTimer();
    this.root.classList.remove('is-mega-open');
    this.mega.classList.remove('is-open');
    this.mega.setAttribute('aria-hidden', 'true');
    this.topItems.forEach((item) => item.classList.remove('is-open'));
    this._hideAllProducts(false);
  }

  _scheduleCloseMega() {
    this._clearCloseTimer();
    this._closeTimer = window.setTimeout(() => {
      this._closeMega();
    }, 220);
  }

  _clearCloseTimer() {
    if (!this._closeTimer) return;
    window.clearTimeout(this._closeTimer);
    this._closeTimer = null;
  }

  _onMegaToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    if (!btn) return;
    const item = btn.closest('[data-kj-mega-item]');
    if (!item) return;
    if (item.classList.contains('is-active')) {
      item.classList.remove('is-active');
      btn.setAttribute('aria-expanded', 'false');
      const sub = item.querySelector('[data-kj-mega-sub]');
      if (sub) {
        sub.querySelectorAll('[data-kj-mega-sub-link]').forEach((el) => el.classList.remove('is-active'));
      }
      this._prepareProductsForParent(this._getActiveParentTitle());
      return;
    }

    this._activateMegaItem(item);
  }

  _onMegaItemEnter(e) {
    const item = e.currentTarget;
    if (!item) return;
    const activeSubLink = e.target && e.target.closest
      ? e.target.closest('[data-kj-mega-sub-link]')
      : null;
    this._activateMegaItem(item, activeSubLink);
  }

  _onMegaSubLinkEnter(e) {
    const a = e.currentTarget;
    if (!a) return;
    const parentTitle = a.getAttribute('data-kj-parent-title');
    const subTitle = a.getAttribute('data-kj-sub-title');
    if (!parentTitle || !subTitle) return;

    const item = a.closest('[data-kj-mega-item]');
    if (item) this._activateMegaItem(item, a);

    a
      .closest('[data-kj-mega-sub]')
      .querySelectorAll('[data-kj-mega-sub-link]')
      .forEach((el) => el.classList.toggle('is-active', el === a));

    this._showProducts(parentTitle, subTitle);
  }

  _showProductsForSubLink(a) {
    const parentTitle = a.getAttribute('data-kj-parent-title');
    const subTitle = a.getAttribute('data-kj-sub-title');
    if (!parentTitle || !subTitle) {
      this._prepareProductsForParent(this._getActiveParentTitle());
      return;
    }
    a
      .closest('[data-kj-mega-sub]')
      .querySelectorAll('[data-kj-mega-sub-link]')
      .forEach((el) => el.classList.toggle('is-active', el === a));
    this._showProducts(parentTitle, subTitle);
  }

  _activateMegaItem(item, activeSubLink) {
    if (!item) return;
    item.classList.add('is-active');
    const btn = item.querySelector('[data-kj-mega-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');

    const subLink = activeSubLink || item.querySelector('[data-kj-mega-sub-link]');
    if (subLink) {
      this._showProductsForSubLink(subLink);
      return;
    }

    const parentTitle = item.getAttribute('data-kj-parent-title');
    const subTitle = item.getAttribute('data-kj-sub-title');
    if (!parentTitle || !subTitle) {
      this._prepareProductsForParent(this._getActiveParentTitle());
      return;
    }
    this._showProducts(parentTitle, subTitle);
  }

  _expandAllMegaItems(panel) {
    if (!panel) return;
    panel
      .querySelectorAll('[data-kj-mega-item][data-kj-collapsible="true"]')
      .forEach((item) => {
        item.classList.add('is-active');
        const btn = item.querySelector('[data-kj-mega-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });
  }

  _showProducts(parentTitle, subTitle) {
    const p = this._normalizeMenuTitle(parentTitle);
    const s = this._normalizeMenuTitle(subTitle);
    const matches = this._getProductContainersForParent(p).filter((el) => {
      return this._normalizeMenuTitle(el.getAttribute('data-kj-sub-title')) === s;
    });

    if (matches.length === 0) {
      const hasVisibleProducts = this.productContainers.some((el) => {
        return !el.hidden &&
          this._normalizeMenuTitle(el.getAttribute('data-kj-parent-title')) === p &&
          this._hasProductMedia(el);
      });

      if (!hasVisibleProducts) this._prepareProductsForParent(parentTitle);
      else this._setProductLayoutState(true);
      return false;
    }

    this.productContainers.forEach((el) => {
      el.hidden = !matches.includes(el);
    });
    this._lastProductSelectionByParent.set(p, s);
    this._setProductLayoutState(true);
    return true;
  }

  _prepareProductsForParent(parentTitle) {
    const p = this._normalizeMenuTitle(parentTitle);
    const available = this._getProductContainersForParent(p);
    if (!p || available.length === 0) {
      this._hideAllProducts();
      return false;
    }

    const previousSelection = this._lastProductSelectionByParent.get(p);
    const fallback = previousSelection
      ? available.find((el) => {
          return this._normalizeMenuTitle(el.getAttribute('data-kj-sub-title')) === previousSelection;
        })
      : null;
    const selected = fallback || available[0];
    const selectedSubTitle = this._normalizeMenuTitle(selected.getAttribute('data-kj-sub-title'));

    this.productContainers.forEach((el) => {
      const sameParent = this._normalizeMenuTitle(el.getAttribute('data-kj-parent-title')) === p;
      const sameSelection = this._normalizeMenuTitle(el.getAttribute('data-kj-sub-title')) === selectedSubTitle;
      el.hidden = !(sameParent && sameSelection && this._hasProductMedia(el));
    });

    this._lastProductSelectionByParent.set(p, selectedSubTitle);
    this._setProductLayoutState(true);
    return true;
  }

  _getProductContainersForParent(parentTitle) {
    const p = this._normalizeMenuTitle(parentTitle);
    if (!p) return [];
    return this.productContainers.filter((el) => {
      return this._normalizeMenuTitle(el.getAttribute('data-kj-parent-title')) === p &&
        this._hasProductMedia(el);
    });
  }

  _getActiveParentTitle() {
    if (!this.mega) return '';
    const activePanel = this.mega.querySelector('[data-kj-mega-panel].is-active');
    return activePanel ? activePanel.getAttribute('data-kj-parent-title') || '' : '';
  }

  _hasProductMedia(container) {
    return Boolean(container && container.querySelector('.mt-kj-header__mega-card-image'));
  }

  _normalizeMenuTitle(value) {
    return (value || '').trim().toLowerCase();
  }

  _hideAllProducts(updateLayout = true) {
    this.productContainers.forEach((el) => {
      el.hidden = true;
    });
    if (updateLayout) this._setProductLayoutState(false);
  }

  _setProductLayoutState(hasProductMedia) {
    if (!this.mega) return;
    this.mega.classList.toggle('is-productless', !hasProductMedia);
  }
}

const mtKjHeaderInstances = new Map();

function initMtKjHeaders() {
  document.querySelectorAll('.mt-kj-header').forEach((root) => {
    const id = root.getAttribute('data-section-id') || root.id || Math.random().toString(36);
    if (mtKjHeaderInstances.has(id)) return;
    mtKjHeaderInstances.set(id, new MtKjHeader(root));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMtKjHeaders);
} else {
  initMtKjHeaders();
}

document.addEventListener('shopify:section:unload', (event) => {
  const root = event.target && event.target.querySelector && event.target.querySelector('.mt-kj-header');
  if (!root) return;
  const id = root.getAttribute('data-section-id') || root.id;
  const inst = mtKjHeaderInstances.get(id);
  if (inst) {
    inst.destroy();
    mtKjHeaderInstances.delete(id);
  }
});

document.addEventListener('shopify:section:load', initMtKjHeaders);
